import React, { useState } from "react";
import classes from "./Section4.module.css";

const ceo = {
  name: "Brian Ballinger",
  position: "Chief Executive Officer",
  description:
    "Brian Ballinger, CEO of PSP, brings extensive experience in the healthcare and health insurance industry to his leadership role. Since the company's inception in 2019, Brian has utilized his deep industry knowledge to drive innovation and deliver exceptional value to clients. His strategic direction and commitment to excellence continue to shape the company's growth and success. As CEO, Brian leads its growth. He uses his deep expertise in the healthcare and insurance industries. He delivers innovative solutions and exceptional client value.",
  image: "/team/brain-ceo.webp",
};

// const teamMembers = [
//   {
//     name: "Jenny Ballinger",
//     position: "Co-Founder & COO",
//     description:
//       "Jenny Ballinger, co-founder and COO of PSP, brings a proven track record as a serial entrepreneur. Since the company's founding in 2019, Jenny has leveraged her years of experience turning innovative ideas into thriving business models. Her strategic vision and operational expertise have been instrumental in driving the growth and success of PSP. As Co-founder and COO, Jenny Ballinger is an entrepreneur. She ensures excellence in operations, turning ideas into successful business models.",
//     image: "/team/jenny.webp",
//   },
//   {
//     name: "Hunter Broadway",
//     position: "Chief Marketing Officer",
//     description:
//       "With extensive experience in marketing across diverse industries, Hunter brings a well-rounded and strategic approach to the role of VP of Marketing at PSP. Hunter has managed marketing initiatives for one of the largest behavioral health companies in the nation and spearheaded data-driven marketing strategies at a leading media company. Now, he is dedicated to driving the growth of PSP and its clients through innovative leadership. Hunter Broadway's diverse marketing experience fuels PSP success. It creates data-driven strategies that help the company and its clients grow in a competitive market.",
//     image: "/team/hunter.webp",
//   },
//   {
//     name: "Katie Broadway",
//     position: "Chief Human Resources Officer",
//     description:
//       "Katie Broadway brings years of recruiting and HR expertise across multiple sectors of healthcare. Known for her strategic leadership, she has spearheaded large-scale recruiting efforts and implemented data-driven strategies to enhance both recruitment and retention. Passionate about fostering positive workplace environments, Katie has also led initiatives that significantly improve company culture. Katie applies her extensive experience to attract top talent, drive employee engagement, and support the mission to deliver excellence. Her dedication to aligning HR strategies with business goals ensures sustainable growth and a thriving workplace culture.",
//     image: "/team/kaite.webp",
//   },
//   {
//     name: "Cornell Jones Sr.",
//     position: "Chief Growth Officer",
//     description:
//       "As a 20+ year U.S. Army Veteran and accomplished business development professional, I bring a unique blend of leadership, vision, and results-driven expertise to every endeavor. My career has been defined by a proven ability to build high-performing teams, exceed sales and marketing goals, and drive growth in highly competitive industries. With over 15 years of experience in recruiting and sales—nine of which were dedicated to U.S. Army healthcare logistics and pharmacy.",
//     image: "/team/jones.webp",
//   },
// ];

export default function Section4() {
  const [popupData, setPopupData] = useState(null);

  const openPopup = (data) => setPopupData(data);
  const closePopup = () => setPopupData(null);

  const handlePopupClick = (e) => e.stopPropagation();

  return (
    <section className={`container ${classes.section4Wrapper}`}>
      {/* First Row: Title & Description */}
      <div className={classes.section4Row}>
        <h2 className={classes.section4Title}>Our Leadership Team</h2>
        <p className={classes.section4Description}>
          Meet the experts driving PSP's mission to deliver excellence in
          healthcare revenue cycle management.
        </p>
      </div>

      {/* Second Row: CEO Card */}
      <div className={classes.section4Row}>
        <div className={classes.section4Card} onClick={() => openPopup(ceo)}>
          <div className={classes.section4CardContent}>
            <div className={classes.section4CardImageWrapper}>
              <img
                src={ceo.image}
                alt={ceo.name}
                className={classes.section4CardImage}
              />
            </div>
            <div className={classes.section4CardText}>
              <p className={classes.section4CardDescription}>
                “{ceo.description}”
              </p>
              <h3 className={classes.section4CardName}>{ceo.name}</h3>
              <h4 className={classes.section4CardPosition}>{ceo.position}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* Third Row: Team Members */}
      {/* <div className={classes.section4Row}>
        <div className={classes.section4TeamGrid}>
          {teamMembers.map((member, idx) => (
            <div
              className={classes.section4TeamCard}
              key={idx}
              onClick={() => openPopup(member)}
            >
              <img
                src={member.image}
                alt={member.name}
                className={classes.section4TeamImage}
              />
              <h3 className={classes.section4TeamName}>{member.name}</h3>
              <h4 className={classes.section4TeamPosition}>
                {member.position}
              </h4>
            </div>
          ))}
        </div>
      </div> */}

      {/* Popup */}
      {popupData && (
        <div className={classes.section4PopupOverlay} onClick={closePopup}>
          <div className={classes.section4Popup} onClick={handlePopupClick}>
            <button className={classes.section4PopupClose} onClick={closePopup}>
              ×
            </button>
            <div className={classes.section4PopupContent}>
              <div className={classes.section4PopupLeft}>
                <img
                  src={popupData.image}
                  alt={popupData.name}
                  className={classes.section4PopupImage}
                />
              </div>
              <div className={classes.section4PopupRight}>
                <h3 className={classes.section4PopupName}>{popupData.name}</h3>
                <h4 className={classes.section4PopupPosition}>
                  {popupData.position}
                </h4>
                <p className={classes.section4PopupDescription}>
                  {popupData.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
